module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-HeavyIt.3bf18432.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/AvenirNextLTPro-HeavyIt.woff
// module id = 102
// module chunks = 0